import { Component, OnInit } from '@angular/core';
import { Color, Modal } from '@lsq-frontend/common-ui';
import { Icons } from '@lsq-frontend/common-ui';
import { ModalService, ModalWorkflowService } from '@lsq-frontend/common-ui';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { BehaviorSubject } from 'rxjs';
import { first, shareReplay, map } from 'rxjs/operators';

@Component({
    selector: 'buyer-upload-success-modal',
    templateUrl: './buyer-upload-success-modal.component.html',
    styleUrls: ['./buyer-upload-success-modal.component.scss']
})
export class BuyerUploadSuccessModalComponent implements OnInit {
    public icons = Icons;
    public colors = Color;
    public title = this._i18n({ value: 'Upload Successful' });
    public subtitleValue$ = new BehaviorSubject('');

    public subtitle: string;
    public modal: Modal;

    constructor(
        public modalService: ModalService,
        private _modalWorkflowService: ModalWorkflowService,
        protected _i18n: I18n
    ) {}

    public ngOnInit(): void {
        this.modal = this.modalService.modal;
    }

    public continueWorkflow(): void {
        this._modalWorkflowService.nextStep();
    }

    public close(): void {
        this._modalWorkflowService.hideWorkflow();
    }

    public setSubtitleValue(name: string): void {
        this.subtitleValue$.next(name);
    }
}
